import { BUTTON_COLOR_PATH } from '../constants/wix-params';
import withSettingsColor from './with-settings-color';

export default withSettingsColor(BUTTON_COLOR_PATH, 'topCommentColor', 'color-8', 1);



// WEBPACK FOOTER //
// ./app/hoc/with-top-comment-color.js